import { OrderCargoOrderFinishedListItem } from "../../../../common/services/order/cargo-order/finished/list/order-cargo-order-finished-list";
import PublicStatus from "../../../../common/types/public-status";
import OrderFinishedListingExecutionStatus from "./types/order-finished-listing-execution-status";
import OrderFinishedListingItem from "./types/order-finished-listing-item";
import OrderFinishedListingPublicStatus from "./types/order-finished-listing-public-status";

const createPublicStatus = (
  status: PublicStatus,
): OrderFinishedListingPublicStatus => {
  switch (status) {
    case PublicStatus.PRIVATE:
      return OrderFinishedListingPublicStatus.PRIVATE;
    case PublicStatus.PUBLIC:
      return OrderFinishedListingPublicStatus.PUBLIC;
    case PublicStatus.PUBLISHED:
      return OrderFinishedListingPublicStatus.PUBLISHED;
  }
};

const createListingItem = (
  listItem: OrderCargoOrderFinishedListItem,
): OrderFinishedListingItem => {
  return {
    uuid: listItem.uuid,
    cargoCompanyExternalOrderId: listItem.externalOrderId,
    cargoCompanyOrderId: listItem.internalOrderId,
    consumerName: listItem.consumer?.name ?? "",
    producerName: listItem.producer?.name ?? "",
    orderDate: new Date(listItem.estimatedStartDate),
    dispatchName: listItem.dispatch,
    drivers: listItem.drivers,
    passengers: listItem.passengers,
    routeAddresses: listItem.routeAddresses,
    publicStatus: createPublicStatus(listItem.publicStatus),
    status: listItem.isCancelled
      ? OrderFinishedListingExecutionStatus.CANCELLED
      : OrderFinishedListingExecutionStatus.FINISHED,
    attentions: {
      newSharedPost: listItem.attentions?.newSharedPost,
      newPlanEntryPost: listItem.attentions?.newPlanEntryPost,
      cargoOrderEdit: listItem.attentions?.cargoOrderEdit,
      cargoOrderCancel: listItem.attentions?.cargoOrderCancel,
    },
    slkStatus: listItem.slkStatus ?? null,
  };
};

const createListingItems = (
  listItems: OrderCargoOrderFinishedListItem[],
): OrderFinishedListingItem[] => {
  return listItems.map(createListingItem);
};

const driverListingItemFactory = {
  createListingItems,
};

export default driverListingItemFactory;
